import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Some source-only deployments omit public/index.html from the upload.
// Ensure mobile browsers use the real device width if the HTML lacks a viewport meta tag.
if (!document.querySelector('meta[name="viewport"]')) {
  const viewport = document.createElement('meta');
  viewport.setAttribute('name', 'viewport');
  viewport.setAttribute('content', 'width=device-width, initial-scale=1');
  document.head.appendChild(viewport);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
